export const config = {
    apiKey: "AIzaSyCAs9DGjlz83CjC2sifVPlMNtjfa_nsSv0",
    authDomain: "swipe-app-horsten.firebaseapp.com",
    projectId: "swipe-app-horsten",
    storageBucket: "swipe-app-horsten.appspot.com",
    messagingSenderId: "1034834447079",
    appId: "1:1034834447079:web:af4f744978bb93da22b042",
};
